import { render, staticRenderFns } from "./BcBtnDialogClose.vue?vue&type=template&id=1ef42b36"
import script from "./BcBtnDialogClose.vue?vue&type=script&lang=js"
export * from "./BcBtnDialogClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports